import { render, staticRenderFns } from "./ActivityFeedItem.vue?vue&type=template&id=e31782ca&"
import script from "./ActivityFeedItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivityFeedItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActivityFeedItem.vue?vue&type=style&index=0&id=e31782ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports